import classNames from 'classnames';
import React from 'react';
import WixLogo from '../../WixLogo/WixLogo';
import BackgroundColor from './constants/BackgroundColor';
import styles from './SplitLayout.scss';

interface ISplitLayoutBase {
  backgroundColor?: BackgroundColor;
  left: React.ReactNode;
  leftNav?: React.ReactNode;
  topNotification?: React.ReactNode;
  children?: React.ReactNode;
}

interface ISplitLayout extends ISplitLayoutBase {
  right?: React.ReactNode;
  rightNav?: React.ReactNode;
  rightWrapperClassName?: string;
  rightContentClassName?: string;
}

interface IRightContentWrapperProps {
  wrapperClassName?: string;
  contentClassName?: string;
  children: React.ReactNode;
}

const RightContentWrapper: React.FC<IRightContentWrapperProps> = (props) => (
  <div
    className={classNames(styles.rightContentWrapper, props.wrapperClassName)}
  >
    <div className={classNames(styles.rightContent, props.contentClassName)}>
      {props.children}
    </div>
  </div>
);

const RightNav: React.FC<{
  children: React.ReactNode;
}> = (props) => <nav className={styles.rightNav}>{props.children}</nav>;

const SplitLayoutBase: React.FC<ISplitLayoutBase> = (props) => (
  <section className={styles.split}>
    <div
      className={styles.leftPart}
      style={{ backgroundColor: props.backgroundColor }}
    >
      <WixLogo className={styles.logo} color="white" />
      <div className={styles.leftContent}>{props.left}</div>
      {props.leftNav ? (
        <nav className={styles.leftNav}>{props.leftNav}</nav>
      ) : null}
    </div>

    <div className={styles.rightPart}>
      {props.children}
      <aside className={styles.topNotification}>{props.topNotification}</aside>
    </div>
  </section>
);

const SplitLayout: React.FC<ISplitLayout> = (props) => (
  <SplitLayoutBase
    left={props.left}
    leftNav={props.leftNav}
    topNotification={props.topNotification}
    backgroundColor={props.backgroundColor}
  >
    <RightContentWrapper
      wrapperClassName={props.rightWrapperClassName}
      contentClassName={props.rightContentClassName}
    >
      {props.right}
    </RightContentWrapper>
    {props.rightNav ? <RightNav>{props.rightNav}</RightNav> : null}
  </SplitLayoutBase>
);

export { SplitLayoutBase, RightNav };

export default SplitLayout;
